<template>
  <section>
    <api-info-block title="请求示例">
      <code-editor title="示例代码" :code="reqExample[0].data"></code-editor>
    </api-info-block>

    <api-info-block title="响应示例" v-show="!callbackStyle">
      <code-editor
        title="JSON示例"
        :code="resExample[0].data"
        code-style="json"
      ></code-editor>
    </api-info-block>

    <api-info-block title="异常示例" v-show="!callbackStyle">
      <code-editor
        title="JSON示例"
        code-style="json"
        :code="errorExample[0].data"
      ></code-editor>
    </api-info-block>
  </section>
</template>

<script>
// eslint-disable-next-line
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import ApiInfoBlock from "./api-info-block.vue";
import CodeEditor from "./code-editor.vue";

export default {
  components: {
    ApiInfoBlock,
    CodeEditor
  },

  props: {
    callbackStyle: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      reqExample: "apiDoc/reqExample",
      resExample: "apiDoc/resExample",
      errorExample: "apiDoc/errorExample"
    })
  }
};
</script>
